import React from 'react';

import { Box, CircularProgress, Skeleton } from '@mui/material';

const SuspenseLoading = ({ width = '300px', height = '300px', skelton, ...props }) => {
  return (
    <Box className='center' width={width} height={height} {...props}>
      {skelton ? (
        <Skeleton variant='rectangular' sx={{ borderRadius: '10px' }} height={'100%'} animation='wave' width={'100%'} />
      ) : (
        <CircularProgress size={30} />
      )}
    </Box>
  )
};

export default SuspenseLoading;